import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { RestService } from 'src/app/rest.service';
import { SchedulerUtils } from 'src/app/utils/scheduler.utils';
import { SystemUtils } from 'src/app/utils/system.utils';
import { TimeZoneUtils } from 'src/app/utils/timezone.utils';
import { MaintenanceOccurence, MaintenanceScheduleRes } from 'src/models/Table';

@Component({
  selector: 'app-schedule-edit-maintenance',
  templateUrl: './schedule-edit-maintenance.component.html',
  styleUrls: ['./schedule-edit-maintenance.component.css']
})
export class ScheduleEditMaintenanceComponent implements OnInit {

  selectedTimeZone: string = "";
  localTimeZone: string = "";
  
  isReviewDateShown: boolean = false;
  isReviewTimeShown: boolean = false;

  disableIncreaseHours: boolean;
  disableDecreaseHours: boolean;

  disableIncreaseMinutes: boolean;
  disableDecreaseMinutes: boolean;

  isSmartMatchChecked: boolean;

  editMachineId: any;
  machineId: any = "";
  hours: any;
  minutes: any;

  isLoadingIcon = false;
  isDifferentTimezone = true;
  isFailure = false;
  failureMessage = '';

  isSuccess = false;
  successMessage = '';

  expandRowId: any;
  
  estHours: any;
  estMintues: any;
  estEditHours: any;
  estEditMintues: any;
  estEditHoursSelection: any = 0;
  estEditMinuteSelection: any = 0;

  startDate: any = "";
  tphours: any = "00";
  tshours:any = '00';
  tsminutes:any="00";
  tpminutes: any = "00";
  tptype: any = "AM";

  @Input() environment;
  @Input() masterEnvId;
  @Input() estHoursSelection;
  @Input() estMinuteSelection;
  @Input() mSchedule: MaintenanceScheduleRes;
  @Input() isSeries: boolean;
  @Input() isEdit: boolean;

  @Input() activityLabel;
  @Input() systemAccess;
  @Input() description;
  @Input() duration;
  @Input() mtnForAllEvn;
  @Input() series;
  @Input() repeatType;

  @Output() onSave = new EventEmitter<any>();

  tableobj: any;
  headerobj: any;
  machineobj: any;

  @Input() occId: any;
  @Input() seriesId: any;

  constructor(private _restService: RestService) { }

  ngOnInit() {
    this.selectedTimeZone = localStorage.getItem('selectedTimeZone');
    this.localTimeZone = localStorage.getItem('localTimeZone');
    
    this.estHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estMintues = Array(60)
      .fill(0)
      .map((x, i) => i);

    this.estEditHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estEditMintues = Array(60)
      .fill(0)
      .map((x, i) => i);
  }

  reviewDateEvent(){
    this.isReviewDateShown = !this.isReviewDateShown;
    this.isReviewTimeShown = false;
  }

  increaseHrs(){
    var hrs = parseInt(this.tphours) + 1;
    this.disableDecreaseHours = false;
    if (hrs >= 12) {
      this.tphours = 12;
      this.disableIncreaseHours = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHours = false;
    }
  }

  decreaseHrs(){
    var hrs = parseInt(this.tphours) - 1;
    this.disableIncreaseHours = false;
    if (hrs <= 0) {
      this.tphours = "00";
      this.disableDecreaseHours = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHours = false;
    }
  }

  increaseMins() {
    var mins = parseInt(this.tpminutes) + 1;
    this.disableDecreaseMinutes = false;
    if (mins > 59) {
      this.disableIncreaseMinutes = true;
    } else {
      this.disableIncreaseMinutes = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMins() {
    var mins = parseInt(this.tpminutes);
    this.disableIncreaseMinutes = false;
    if (mins === 0) {
      this.disableDecreaseMinutes = true;
      this.tpminutes = "00";
    } else {
      mins = parseInt(this.tpminutes) - 1;
      this.disableDecreaseMinutes = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  reviewTimeEvent(rowId: number){
    this.isReviewTimeShown = !this.isReviewTimeShown;
    this.isReviewDateShown = false;
  }

  closeDate(){
    var d = localStorage.getItem("cancelDate");
    this.startDate = d.split("/").reverse().join("-");
    localStorage.setItem("singleDate", d);
    localStorage.setItem('mSingleDate',d);
    this.isReviewDateShown = false;
  }

  applyDate(){
    var d = localStorage.getItem("singleDate");
    this.startDate = d.split("/").reverse().join("-");


    //const tableobj = this.jobScheduleResponse.scheduleListRes.OccuranceTable;
    const tableobj = [];

    tableobj.map(
      (f: any) => (
        console.log(f.NewStart + "---" + this.startDate + "---" + d),
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString())
      )
    );

   
    console.log("Dates -->", tableobj);

    localStorage.setItem("singleDate", d);
    localStorage.setItem("cancelDate", d);
    localStorage.setItem("mSingleDate", d);
    //this.isRangeStartShown = false;
    this.isReviewDateShown = false;
  }

  closeTime(){
    this.isReviewTimeShown = false;
  }

  changetimeformat(){
    var f = this.tptype;
    f === "AM" ? (this.tptype = "PM") : (this.tptype = "AM");
  }

  estEditMinutesEvent(event: any){
    var mins = parseInt(event.target.value);
    var hrs = this.estEditHoursSelection;
  }

  estEditHoursEvent(event: any){
    var hrs = parseInt(event.target.value);
    if (hrs === 24) {
      this.estEditMinuteSelection = 0;
      this.estEditMintues = Array(1)
        .fill(0)
        .map((x, i) => i);
    } else {
      this.estEditMintues = Array(60)
        .fill(0)
        .map((x, i) => i);
    }
  }

  cancelSchedule(id: any) {
    var t = this.mSchedule.maintenanceRes.OccuranceTable;
    t.filter((f: any) =>
      f.rowid === id
        ? f.isfold === true
          ? (f.isfold = false)
          : (f.isfold = true)
        : ""
    );
  }

  resetSchedule(id: any) {
    this.chartExpandEvent(id);
  }

  chartExpandEvent(id: any) {
    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;
    var col = this.mSchedule.maintenanceRes.OccuranceTable;
    this.expandRowId = id;

    col.filter((f: any) =>
      parseInt(f.rowid) === parseInt(id)
        ? f.isfold === false
          ? (f.isfold = true)
          : (f.isfold = false)
        : (f.isfold = false)
    );

    console.log("col", col);
    this.tableobj = col;

    console.log("Ckeck 1", this.tableobj);
    console.log("Ckeck 3", this.machineId);

    var t = col;
    t.filter((f: any) =>
      f.rowid === id
        ? (this.isSeries
          ? (this.editMachineId = this.machineId)
          : (this.editMachineId = f.machineId),
          (this.startDate = f.NewStart),
          localStorage.setItem(
            "cancelDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "singleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "mSingleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          )
          )
        : ""
    );

    t.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.NewStart).getHours() > 12
          ? (new Date(f.NewStart).getHours() - 12).toString().length > 1
            ? (this.tphours = new Date(f.NewStart).getHours() - 12)
            : (this.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
          : new Date(f.NewStart).getHours() === 12
            ? (this.tphours = new Date(f.NewStart).getHours())
            : new Date(f.NewStart).getHours() < 12
              ? new Date(f.NewStart).getHours().toString().length > 1
                ? (this.tphours = new Date(f.NewStart).getHours())
                : (this.tphours = "0" + new Date(f.NewStart).getHours())
              : "",
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          new Date(f.NewStart).getHours() >= 12
            ? (this.tptype = "PM")
            : new Date(f.NewStart).getHours() < 12
              ? (this.tptype = "AM")
              : "")
        : ""
    );

    t.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.startDateBefore).getHours() > 12
          ? (new Date(f.startDateBefore).getHours() - 12).toString().length > 1
            ? (this.tshours = new Date(f.startDateBefore).getHours() - 12)
            : (this.tshours = "0" + (new Date(f.startDateBefore).getHours() - 12))
          : new Date(f.startDateBefore).getHours() === 12
            ? (this.tshours = new Date(f.startDateBefore).getHours())
            : new Date(f.startDateBefore).getHours() < 12
              ? new Date(f.startDateBefore).getHours().toString().length > 1
                ? (this.tshours = new Date(f.startDateBefore).getHours())
                : (this.tshours = "0" + new Date(f.startDateBefore).getHours())
              : "",
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          new Date(f.NewStart).getHours() >= 12
            ? (this.tptype = "PM")
            : new Date(f.NewStart).getHours() < 12
              ? (this.tptype = "AM")
              : "")
        : ""
    );

    const headerObj = this.mSchedule.maintenanceRes.headerObj;

    let duration = [];
    headerObj.hasOwnProperty("duration")
      ? (duration = headerObj.duration.split(":"))
      : "";

    console.log("tshours --->", this.tshours);

    this.estEditHoursSelection = parseInt(duration[0]);
    this.estEditMinuteSelection = parseInt(duration[1]);

    console.log("duration --->", this.estEditHoursSelection);

  }

  mseriesSave() {
    this.isLoadingIcon = true;
    var count = 0;
    console.log("4---->", this.tableobj);
    this.tableobj = this.mSchedule.maintenanceRes.OccuranceTable;
    var l = this.tableobj.length;
    var startDt = this.tableobj[0].startDateBefore;
    var endDt = this.tableobj[l - 1].endDateBefore;
    console.log("4-1---->", startDt + "---" + endDt);
    let occuranceList = [];
    this.tableobj.map((m: any) =>
      occuranceList.push({
        NewStart: m.startDateBefore,
        NewEnd: m.endDateBefore,
        Status: m.Status,
        conflictMid: m.conflictMid,
        conflictSid: m.conflictMid
      })
    );
    console.log("5---->", occuranceList);

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString())
      )
    );

    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage =
          "Maintenance(s) creating date can not be duplicate"))
      : "";

    this.tableobj.map((f: any) =>
      new Date(f.createdDate).getTime() < new Date(f.todayDate).getTime()
        ? ((this.isLoadingIcon = false),
          (count = count + 1),
          (this.isFailure = true),
          (this.failureMessage =
            "Maintenance(s) creating date should be greater than current date & time"))
        : ""
    );

    
    if (count == 0){
      this._restService.saveRecMaintenance(
          this.environment,
          this.activityLabel,
          this.description,
          this.series,
          this.repeatType,
          startDt,
          endDt,
          this.systemAccess,
          this.duration,
          occuranceList,
          this.masterEnvId,
          this.mtnForAllEvn
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            this.isSuccess = true,
            this.successMessage = f.response,
            this.onSave.emit()
        ))
    }
  }


  updateMaintenance(id: any, tbl: any){
    if (!this.isSeries){
      this.updateMaintenanceSingle(id, tbl);
    }else {
      this.updateMaintenanceSeries(tbl);
    }
  }

  updateMaintenanceSingle(e: any,tbl:any) {
    console.log("entry 1");
    console.log("converted---->", tbl)

    this.isLoadingIcon = true;
    var hm = [];
    var count = 0;
    console.log("log", this.tableobj);
    
    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;
      // var timeZoneFromDB: any = localStorage.getItem('timezoneName');

    var t: any;
    var sd: any;
    var sdt: any;

    this.tableobj = this.mSchedule.maintenanceRes.OccuranceTable;
    this.headerobj = this.mSchedule.maintenanceRes.headerObj;

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) =>
      (f.start = (
        new Date(f.NewStart).getFullYear() +
        "-" +
        (new Date(f.NewStart).getMonth() + 1) +
        "-" +
        new Date(f.NewStart).getDate()
      ).toString())
    );
    var dm = localStorage.getItem("mSingleDate").split("/").reverse().join("-");
   
    this.tableobj.map(
      (f: any) =>
      (f.start = (
        new Date(f.NewStart).getFullYear() +
        "-" +
        (new Date(f.NewStart).getMonth() + 1) +
        "-" +
        new Date(f.NewStart).getDate()
      ).toString())
    );

    const hr = this.tptype == 'PM' && this.tphours != 12 ? parseInt(this.tphours) + 12 : this.tphours;
    var dates = d + ' ' + hr + ':' + this.tpminutes + ':' + '00';
    //dates = TimeZoneUtils.timezoneConvert(dates);

    var hour = new Date(dates).getHours().toString().padStart(2, "0");
    var minute = new Date(dates).getMinutes().toString().padStart(2, "0")

    var range = {
      startTime: {
        hours: hour.toString(),
        minutes: minute.toString(),
      },
      end: {
        endTime: {
          hours: "00",
          minutes: "00",
          totalDuration: "00",
        },
        duration: {
          hours: this.estEditHoursSelection.toString(),
          minutes: this.estEditMinuteSelection.toString(),
        },
        isEndTime: false,
      },
    };
    

    //this.tableobj.map((f: any) => alert(f.rowid + "--" + this.expandRowId));
    var dts;


    if (this.isEdit){
        this.tableobj.map((f: any) =>
          f.rowid !== this.expandRowId
            ? f.start === d
              ? ((this.isLoadingIcon = false),
                (count = count + 1),
                (this.isFailure = true),
                (this.failureMessage = "Selected date is already exists"))
              : ""
            : ""
        );

        var sdateMtn = [];
        this.tableobj.length === 1 ? sdateMtn.push(dm) : "";
        dts = sdateMtn;
    }else{
      this.tableobj.map((f: any) =>
      f.rowid !== this.expandRowId
        ? f.start === d
          ? ((this.isLoadingIcon = false),
            (count = count + 1),
            (this.isFailure = true),
            (this.failureMessage = "Selected date is already exists"))
          : ((t = localStorage.getItem("singleDate")),
            (sd = localStorage.getItem("selectedDates").split(",")),
            console.log("SDT", sd),
            sd.map((f: any, i: any) =>
              i + 1 === this.expandRowId ? (sd[i] = t) : ""
            ),
            (sdt = sd.map((m: any) => (m = m.split("/").reverse().join("-")))),
            localStorage.setItem("selectedDates", sd.toString()))
        : ((sd = localStorage.getItem("selectedDates").split(",")),
          (sdt = sd.map((m: any) => (m = m.split("/").reverse().join("-")))))
      );
      sdt = sdt.filter(function (el) {
        return el != "";
      });

      var sdateMtn = [];
      this.tableobj.length === 1 ? sdateMtn.push(dm) : "";
      var dts = this.tableobj.length === 1 ? sdateMtn : sdt; 
    }

    count === 0
      ? this.estEditHoursSelection.toString() === "0" &&
        this.estEditMinuteSelection.toString() === "0"
        ? ((this.isLoadingIcon = false),
          (this.isFailure = true),
          (this.failureMessage = "Estimated duration time is required"))
        : this._restService
          .createMaintenanceSchedule(
            this.activityLabel,
            this.environment,
            this.systemAccess,
            this.description,
            dts,
            range,
            this.isEdit,
            this.isEdit ? this.occId : 0,
            this.masterEnvId
          )
          .pipe(
            catchError((e) => {
              (this.isLoadingIcon = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.response
                  ? e.error.response
                  : e.error.StatusInfo);
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              console.log(f),
              (this.tableobj = []),
              this.mSchedule = f,
              (this.headerobj = f.maintenanceRes.headerObj),
              (this.tableobj = f.maintenanceRes.OccuranceTable),
              this.tableobj.filter((m: any) => (m.isfold = false)),
              this.tableobj.filter(
                (m: any, index: any) => (m.rowid = index + 1)
              ),
              this.headerobj.hasOwnProperty("duration")
                ? ((hm = this.headerobj.duration.split(":")),
                  (this.headerobj.hours = hm[0]),
                  (this.headerobj.mins = hm[1]))
                : "",
              this.tableobj.filter(
                (m: any, index: any) => (
                  (m.startDateBefore = (m.NewStart)),
                  (m.endDateBefore = (m.NewEnd)),
                  (m.NewStart = TimeZoneUtils.timezoneConvert(m.NewStart)),
                  (m.NewEnd = TimeZoneUtils.timezoneConvert(m.NewEnd)),
                  console.log("end 14", m.startDateBefore)
                ),
              ),
              this.tableobj.filter((m: any) =>
                SchedulerUtils.updateMaintenanceObject(m)
              ),
              console.log("table final1 ---->>>>>", this.tableobj),
              (this.isLoadingIcon = false)
            )
          )
      : "";
  }

  updateMaintenanceSeries(tbl:any) {
    console.log("tbl----" , tbl);
    var occid;
    console.log("occid----" + occid);
    
    // this.occID = occid;
    this.isLoadingIcon = true;
    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;

      var sds = new Date(this.startDate).toLocaleDateString("fr-CA");
      var sm = sds.split("/").reverse().join("-");
      // var sdt = [];
      // sdt.push(s);

      var dates = sm + ' ' + shour + ':' + this.tpminutes + ':' + '00';
      //dates = TimeZoneUtils.timezoneConvert(dates);
  
      var hour = new Date(dates).getHours().toString().padStart(2, "0");
      var minute = new Date(dates).getMinutes().toString().padStart(2, "0")
  
      var range = {
        startTime: {
          hours: hour.toString(),
          minutes: minute.toString(),
        },
        end: {
          endTime: {
            hours: "00",
            minutes: "00",
            totalDuration: "00",
          },
          duration: {
            hours: this.estEditHoursSelection.toString(),
            minutes: this.estEditMinuteSelection.toString(),
          },
          isEndTime: false,
        },
      };

    var sd = new Date(this.startDate).toLocaleDateString("fr-CA");
    var s = sd.split("/").reverse().join("-");
    var sdt = [];
    sdt.push(s);
    console.log("dates--->" + JSON.stringify(sdt));
    this.headerobj = this.mSchedule.maintenanceRes.headerObj;
    this.tableobj = this.mSchedule.maintenanceRes.OccuranceTable;


    this._restService
      .createMaintenanceSchedule(
                 this.activityLabel,
                  this.environment,
                  this.systemAccess,
                  this.description,
                  sdt,
                  range,
                  this.isEdit,
                  this.expandRowId,
                this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("1", f),
          //this.mSchedule = f,
          //response.headerObj
         
          this.mSchedule.maintenanceRes.OccuranceTable.filter(
            (m: any, i: any) =>
              parseInt(m.rowid) === parseInt(this.expandRowId)
                ? (m.isEdited = true)
                : ""
          ),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          // (this.tableobj = []),
          // (this.headerobj = this.mtnRecurringRes.response.headerObj),
          // (this.tableobj = this.mtnRecurringRes.response.OccuranceTable),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.endTime = new Date(m.NewEnd).getTime()),
              (m.startTime = new Date(m.NewStart).getTime())
            )
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.seconds = (m.endTime - m.startTime) / 1000),
              (m.duration =
                Math.floor(m.seconds / 3600) +
                ":" +
                (Math.floor(m.seconds / 60) % 60))
            )
          ),
          this.tableobj.filter(
            (m: any, i: any) =>
              parseInt(m.rowid) === parseInt(this.expandRowId)
                ? Object.assign(m, f.maintenanceRes.OccuranceTable[0])
                : ""
          ),
          f.maintenanceRes.OccuranceTable.filter((m:any) => (
            console.log("data...." ,(f.maintenanceRes.OccuranceTable[0])),
            m.sstartbefore = f.maintenanceRes.OccuranceTable[0].NewStart,
            m.sendbefore = f.maintenanceRes.OccuranceTable[0].NewEnd,
            m.sstart = TimeZoneUtils.timezoneConvert(f.maintenanceRes.OccuranceTable[0].NewStart),
            m.send = TimeZoneUtils.timezoneConvert(f.maintenanceRes.OccuranceTable[0].NewEnd),
            m.rowid = this.expandRowId,

           this.tableobj.filter(function (item) {

                  if(item.rowid === m.rowid) {
                    
                  console.log("m---", (item.NewStart)),
                  (item.startDateBefore = m.sstartbefore),
                  (item.endDateBefore = m.sendbefore),
                  (item.NewStart = m.sstart),
                  (item.NewEnd = m.send)
                  } 
                })            
          )
          ),
          console.log("table 1", this.tableobj),
          console.log("table final ---->>>>>", this.tableobj),
          this.tableobj.filter((m: any) =>
          SchedulerUtils.updateMaintenanceObject(m)
        ),
          (this.isLoadingIcon = false)
        )
      );
  }

  mSingleUpdate(){
    console.log("entry of edit--->");
    
    this.isLoadingIcon = true;
    //console.log("this.MSingleRes", this.MSingleRes);
    let header = this.mSchedule.maintenanceRes.headerObj;
    let occuranceTable = this.mSchedule.maintenanceRes.OccuranceTable;
    //console.log("header", header);
    //console.log("occuranceTable", occuranceTable);

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this._restService
      .editMOccurance(
        this.occId,
        this.environment,
        header.activityLabel,
        header.description,
        occuranceTable[0].startDateBefore,
        occuranceTable[0].endDateBefore,
        header.duration,
        occuranceTable[0].Status,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("msingleSave", f),
          this.onSave.emit(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          (this.isLoadingIcon = false)
        )
      );
  }

  mSeriesUpdate(){
    this.isLoadingIcon = true;

    this.headerobj = this.mSchedule.maintenanceRes.headerObj;
    this.tableobj = this.mSchedule.maintenanceRes.OccuranceTable;

    this.tableobj.filter(
      (m: any, index: any) => (
        (m.NewStart = new Date(m.startDateBefore).toISOString()),
        (m.NewEnd = new Date(m.endDateBefore).toISOString()),
        console.log("end 12", JSON.stringify(m.startDateBefore))
      ),
    ),

    this._restService
      .editRecMaintenance(
        this.environment,
        this.seriesId,
        this.headerobj,
        this.tableobj,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          this.onSave.emit(),
          (this.isSuccess = true),
          (this.successMessage = f.response),
          (this.isLoadingIcon = false)
        )
      );
  }

  save(){
    if (this.isEdit){
      if (!this.isSeries){
        this.mSingleUpdate();
      }else{
        this.mSeriesUpdate();
      }
      return;
    }

    if (this.isSeries){
      this.mseriesSave();
    }else{
      this.msingleSave();
    }
  }

  msingleSave() {
    this.isLoadingIcon = true;
    var count = 0;

    this.tableobj = this.mSchedule.maintenanceRes.OccuranceTable;

    let occuranceList = [];
    this.tableobj.map((m: any) =>
      occuranceList.push({
        NewStart: m.startDateBefore,
        NewEnd: m.endDateBefore,
        Status: m.Status,
        conflictMid: m.conflictMid,
        conflictSid: m.conflictSid
      })
    );

    console.log("5---->", occuranceList);

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString())
      )
    );


    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage =
          "Maintenance(s) creating date can not be duplicate"))
      : "";

    count === 0
      ? this._restService
        .saveMaintenance(
          this.environment,
          this.activityLabel,
          this.description,
          this.duration,
          this.systemAccess,
          occuranceList,
          this.masterEnvId,
          this.mtnForAllEvn
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.isSuccess = true),
            ((this.successMessage = f.StatusInfo),
              this.onSave.emit(),
              (this.isLoadingIcon = false))
          )
        )
      : "";
  }

  getEnvAccess(tbl){
    if (tbl && tbl.MaintenaceAccess && tbl.MaintenaceAccess.length){
      return tbl.MaintenaceAccess;
    }
    const header = this.mSchedule.maintenanceRes.headerObj;
    const evnAccessList = SystemUtils.createEnvAccess(header.description, header.envName);

    const evnAccess = evnAccessList[0] as any;

    evnAccess.Mlist = [
      {
        activity_label: header.activityLabel,
        endDate: tbl.NewEnd,
        isNew: !this.isEdit,
        startDate: tbl.NewStart
      }
    ];

    tbl.MaintenaceAccess = evnAccessList;
    this.updateOccurenceTable(tbl);

    return evnAccessList;
  }

  updateOccurenceTable(m: any){
    if (!m.MaintenaceAccess){
      return;
    }

    m.MaintenaceAccess.forEach(a => {
      if (!a.Mlist){
        return;
      }

      // Timezone already converted initially before rerendering
      a.Mlist.forEach(d => {
        d.start = d.startDate //TimeZoneUtils.timezoneConvert(d.startDate);
        d.end = d.endDate //TimeZoneUtils.timezoneConvert(d.endDate);
        d.startHour = new Date(d.start).getHours();
        d.startMinutes = new Date(d.start).getMinutes();
        d.endHours = new Date(d.end).getHours();
        d.endMinutes = new Date(d.end).getMinutes();
        d.position = parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70;
        d.length = parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
        d.length += (new Date(d.end).getDay() == new Date(d.start).getDay() ? 0 : 1) * 24 * 70;
        m.doubleDays = d.length > 1748 || m.doubleDays;
      });
    });
  }

  sortSchedule(scheduleArr){
    (scheduleArr as any []).sort((a, b) => {
      const ascore = (a.IsNew || a.isNew) ? 1 : 0;
      const bscore = (b.IsNew || b.isNew) ? 1 : 0;

      return ascore - bscore;
    });

    return scheduleArr;
  }
}
